import { useNotification } from "components/Notification/useAddNotification";

export const useLogoutNotification = () => {
  const { addNotification } = useNotification();
  const title = "Wylogowanie";

  const showSuccessNotification = () =>
    addNotification({
      title: title,
      description: "Pomyślnie wylogowano",
      type: "success",
    });

  const showErrorNotification = () =>
    addNotification({
      title: title,
      description: "Nie udało się wylogować użytkownika",
      type: "error",
    });

  return { showSuccessNotification, showErrorNotification };
};
